import React, { useState, useEffect } from "react";
import SectionHeader from "../Sections/SectionHeader";
import TestimonialCard from "../Sections/TestimonialCard";
import "./TestimonialsSection.css";

export default function TestimonialsSection() {
  const testimonials = [
    {
      quote:
        "AI Squared completely transformed how our guests book and interact. The WhatsApp concierge feels so natural — guests say it’s like texting a real human.",
      name: "Amira A.",
      role: "Operations Director",
      company: "Sam’s Story Hotels",
      image: "/assets/amira.jpg",
    },
    {
      quote:
        "Our restaurant reservations doubled since integrating AI Squared. It handles messages instantly and remembers guests’ preferences perfectly.",
      name: "Karim E.",
      role: "General Manager",
      company: "Oasis Fine Dining",
      image: "/assets/karim.jpg",
    },
    {
      quote:
        "AI Squared is the assistant we didn’t know we needed — it saved our team hours each day while keeping our clients happier than ever.",
      name: "Nadia R.",
      role: "Founder",
      company: "Serene Wellness Clinics",
      image: "/assets/nadia.jpg",
    },
  ];

  const [current, setCurrent] = useState(0);
  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  useEffect(() => {
    const interval = setInterval(next, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials-section">
      {/* Background glow */}
      <div className="testimonials-bg" />

      {/* Header */}
      <SectionHeader
        title="Loved By Hotels,<br/>Restaurants, And Clinics That Redefine Hospitality."
        subtitle="Real stories from visionary brands using AI Squared to deliver seamless, elegant, and intelligent guest experiences — every day."
      />

      {/* Carousel */}
      <div className="carousel-wrapper">
        <button className="nav-btn prev" onClick={prev}>
          ‹
        </button>

        <div className="carousel">
          {testimonials.map((t, index) => {
            const offset = (index - current + testimonials.length) % testimonials.length;
            const className = `card ${offset === 0 ? "active" : offset === 1 ? "next" : offset === 2 ? "behind" : "hidden"}`;
            return (
              <div key={index} className={className}>
                <TestimonialCard {...t} />
              </div>
            );
          })}
        </div>

        <button className="nav-btn next" onClick={next}>
          ›
        </button>
      </div>

      {/* CTA */}
      <div className="testimonials-cta">
        <p>Join 200+ hospitality leaders shaping the future of intelligent luxury.</p>
        <button>Explore Dashboard</button>
      </div>
    </section>
  );
}
